// extracted by mini-css-extract-plugin
module.exports = {"Header":"styles_Header__3n9Vo","Headline":"styles_Headline__3l3zE"};